import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl22 } from '../../../models'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { useBefehlForm } from '../../../hooks'
import {
  convertBefehl22FormDataToModel,
  convertModelToBefehl22FormData
} from './converters'
import { Befehl22FormData, createBefehl22FormValidationSchema } from './schema'
import Auftrag22_10Form from './Auftrag22_10Form'

export default function Befehl22Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-22-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl22>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl22FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl22FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl22FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl22FormData) => {
      const updatedBefehl = convertBefehl22FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl22FormData>
      befehlKennung="22"
      title={t('befehle.22.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      <Auftrag22_10Form
        readOnly={readOnly}
        fieldPrefix="auftrag22_10"
        data-testid={`${testId}-auftrag-22-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
